"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInternalNodes = void 0;
var merge_1 = __importDefault(require("lodash/merge"));
var engine_types_1 = require("@verified/c11-engine.types");
var getDeps_1 = require("./getDeps");
var getInternalNodes = function (op, ns) {
    if (ns === void 0) { ns = "internal"; }
    var graph = {};
    if (op.type === engine_types_1.OperationTypes.STRUCT) {
        Object.keys(op.value).forEach(function (x) {
            var id = ns + "." + x;
            graph = (0, merge_1.default)(graph, (0, exports.getInternalNodes)(op.value[x], id));
        });
    }
    else {
        var nesting = ns.replace(/^internal\./, "");
        var node = {
            id: ns,
            nesting: nesting,
            nestingPath: nesting.split("."),
            path: undefined,
            op: op,
            type: engine_types_1.GraphNodeType.INTERNAL,
            value: undefined,
            dependsOn: (0, getDeps_1.getDeps)(op),
            isDependedBy: [],
            removeListener: undefined,
            removeFuncListeners: {},
            listenersFromConstructors: {},
        };
        graph[ns] = node;
    }
    return graph;
};
exports.getInternalNodes = getInternalNodes;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0SW50ZXJuYWxOb2Rlcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ncmFwaC9nZXRJbnRlcm5hbE5vZGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLHVEQUFpQztBQUNqQyxrREFNMkI7QUFDM0IscUNBQW9DO0FBRTdCLElBQU0sZ0JBQWdCLEdBQUcsVUFBQyxFQUFhLEVBQUUsRUFBdUI7SUFBdkIsbUJBQUEsRUFBQSxlQUF1QjtJQUNyRSxJQUFJLEtBQUssR0FBbUIsRUFBRSxDQUFDO0lBQy9CLElBQUksRUFBRSxDQUFDLElBQUksS0FBSyw2QkFBYyxDQUFDLE1BQU0sRUFBRTtRQUNyQyxNQUFNLENBQUMsSUFBSSxDQUFDLEVBQUUsQ0FBQyxLQUFLLENBQUMsQ0FBQyxPQUFPLENBQUMsVUFBQyxDQUFDO1lBQzlCLElBQUksRUFBRSxHQUFNLEVBQUUsU0FBSSxDQUFHLENBQUM7WUFDdEIsS0FBSyxHQUFHLElBQUEsZUFBSyxFQUFDLEtBQUssRUFBRSxJQUFBLHdCQUFnQixFQUFDLEVBQUUsQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLEVBQUUsRUFBRSxDQUFDLENBQUMsQ0FBQztRQUMxRCxDQUFDLENBQUMsQ0FBQztLQUNKO1NBQU07UUFDTCxJQUFNLE9BQU8sR0FBRyxFQUFFLENBQUMsT0FBTyxDQUFDLGFBQWEsRUFBRSxFQUFFLENBQUMsQ0FBQztRQUM5QyxJQUFNLElBQUksR0FBc0I7WUFDOUIsRUFBRSxFQUFFLEVBQUU7WUFDTixPQUFPLFNBQUE7WUFDUCxXQUFXLEVBQUUsT0FBTyxDQUFDLEtBQUssQ0FBQyxHQUFHLENBQUM7WUFDL0IsSUFBSSxFQUFFLFNBQVM7WUFDZixFQUFFLElBQUE7WUFDRixJQUFJLEVBQUUsNEJBQWEsQ0FBQyxRQUFRO1lBQzVCLEtBQUssRUFBRSxTQUFTO1lBQ2hCLFNBQVMsRUFBRSxJQUFBLGlCQUFPLEVBQUMsRUFBRSxDQUFDO1lBQ3RCLFlBQVksRUFBRSxFQUFFO1lBQ2hCLGNBQWMsRUFBRSxTQUFTO1lBQ3pCLG1CQUFtQixFQUFFLEVBQUU7WUFDdkIseUJBQXlCLEVBQUUsRUFBRTtTQUM5QixDQUFDO1FBQ0YsS0FBSyxDQUFDLEVBQUUsQ0FBQyxHQUFHLElBQUksQ0FBQztLQUNsQjtJQUNELE9BQU8sS0FBSyxDQUFDO0FBQ2YsQ0FBQyxDQUFDO0FBMUJXLFFBQUEsZ0JBQWdCLG9CQTBCM0IifQ==